<script setup>

</script>

<template>
  <span class="inline-flex items-center justify-center h-full">
    <img
      class="h-full"
      src="@/assets/images/futures/bonusPosition.svg?url"
    >
  </span>
</template>
